module.exports = __webpack_public_path__ + "img/preview_75npa.b0ce12fa.png";